import Head from "next/head";
import { useRouter } from "next/router";

import { useState, useEffect, useRef } from "react";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';

import Image from 'next/image';

import Scrollspy from "react-scrollspy"
import ReactMarkdown from "react-markdown";
import emailjs from 'emailjs-com';
import { request } from "graphql-request"

import FsLightbox from "fslightbox-react";
import Lottie from 'react-lottie-player';


import { YachtCard } from "../../components/yachts/YachtCard";

import { GET_YACHT, GET_MENU_YACHTS, GET_FOOTER, GET_LATEST_YACHTS, GET_YACHTS, GET_FEATURES, GET_SPECTS, GET_YACHT_CONTACT } from "../../lib/queries.js";
import { Header } from "../../components/Header.js";


import Layout from "../../components/layout.js";
import { ErrorForm, SuccesForm } from "../../components/Icons.js";
import { useForm } from "react-hook-form";
import styles from '../../styles/yacht.module.scss';
import { ImageMagnifier } from '../../components/ImageMagnifier';
import * as fbq from '../../lib/fpixel'

import lottieJson from '../../public/check.json'



export async function getServerSideProps(context) {
  try{
    const { params, locale } = context;

    const { yachts: yachtData } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_YACHT,
      {
        slug: params.yachtId,
        locale: locale,
      },
    )
    const { yachts } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_MENU_YACHTS,
      { locale: locale },
    )
    const { footer } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_FOOTER,
      { locale: locale },
    )

    const { yachts: latestYachts} = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_LATEST_YACHTS,
      { locale: locale },
    )
    
    if (!yachtData || !footer || !latestYachts) {
      return {
        notFound: true,
      };
    }
  
    const { yachts: suggest } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_YACHTS,
      {
        locale: locale,
        modelSlug: yachtData[0].model.model
      },
    )

    const { yachtContact } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_YACHT_CONTACT,
      { locale: locale },
    )
    
    return {
      props: {
        yachtData: yachtData[0],
        navbar: yachts,
        footer,
        latestYachts,
        suggest: suggest.slice(0,3),
        yachtContact
      },
    };
  }catch(error){
    return {
      notFound: true,
    };
  }
};

export default function NewsPost({ yachtData, navbar, footer, latestYachts, suggest, yachtContact }) {
  const router = useRouter();

  const [showGallery, setGallery] = useState(false);
  const closeGallery = () => setGallery(false);
  const openGallery = () => {
    setGallery(true);
  }

  const dynamicRoute = useRouter().asPath;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 2000); 
  }, []);

  return (
    
    <Layout header={navbar} footer={footer} latestYachts={latestYachts}>

      <Head>
        <title>Yachting México | {yachtData?.title}</title>

        <meta property="og:image" content={yachtData?.thumbnail.url} />
        <meta
          name="description"
          content={yachtData?.description?.substring(0, 97) + "..."}
        />
      </Head>
      
      <Header
        className={styles.header_yacht}
        title={yachtData?.title}
        imgSrc={yachtData.poster.url}
        imgAlt={yachtData.poster.alternativeText}
        rootLabel={router.locale === "es" ? "Inicio" : "Home" }
      />

      <article
        className={`${styles.yacht} mt-0 mt-md-8 mt-lg-10  mb-4 mb-md-7 mb-lg-10`}
        
      >

        {(yachtData.exterior?.length > 0|| yachtData.interior.length) && (
            <GalleryMovil data={yachtData} openGallery={openGallery}/>
        )}
        
        <Gallery locale={router.locale} data={yachtData} openGallery={openGallery} showGallery={showGallery} closeGallery={closeGallery}/>

        <div className={styles.labels}>
         
          <Scrollspy
            items={['gallery','specifications', 'design']}
            currentClassName='currentScroll'
            className="row mb-0 px-3 py-0 py-md-3 justify-content-md-center"
          >
            {(yachtData.exterior.length > 0 || yachtData.interior.length > 0) && (
              <Button  
                onClick={()=>openGallery()}
                variant="outline-primary"
                className={`${styles.btn_section} ${styles.btn_photos}`}
              >
                {router.locale === "es" ? "Fotos" : "Gallery"}
              </Button>
            )}

            <Button
              href="#specifications"
              variant="outline-primary"
              className={styles.btn_section}
            >
              {router.locale === "es" ? "Especificaciones" : "Specifications"}
            </Button>

            
            
            {yachtData.levels.length > 0 && (
              <Button
                href="#design"
                variant="outline-primary"
                className={styles.btn_section}
              >
                {router.locale === "es" ? "Diseño" : "Layout"}
              </Button>
            )}
            {yachtData.url3DView && (

              <View3D url={yachtData.url3DView} locale={router.locale}/>
            )}

            {yachtData.youtubeURL && (  
              <FrameYoutube locale={router.locale} id="VideoTour" url={yachtData.youtubeURL} />
            )}
          </Scrollspy>
        </div>

        <Row className={`mb-6 mb-md-7 mb-lg-8 ${styles.description}`}>
          
          <Col lg={8}>
            {yachtData.description && (
              <Description content={yachtData.description} />
            )}

            <Features content={yachtData?.feature} />

            {yachtData.specification.length > 1 && (
              <Spec content={yachtData.specification} />
            )}

            {yachtData.specification.length < 1 && yachtData.specifications && (
              <Specs content={yachtData.specifications} />
            )}

            
          </Col>

          <Col lg={4} className="d-none d-lg-block">
            <FormAppointment slug={yachtData.title} text={yachtContact.text}/>
          </Col>
        </Row>

        {yachtData.levels.length > 0 && (
            <Levels levels={yachtData.levels} locale={router.locale}/>
        )}

       
        <div className={styles.fixedButton}>
          <Button href="#form" variant='primary' >{router.locale == 'es' ? 'Agenda una visita' : 'Contact us'}</Button>
        </div>
        <Row className={`d-lg-none position-relative ${styles.formContainer}`}>
          <div id='form' className={styles.formSect} />
          <FormAppointment />
        </Row>

        {suggest.length > 0 &&(
          <div className={styles.suggestsContainer}>
          <h3 className={styles.suggestsTitle}>Modelos similares</h3>
          <div className={styles.suggests}>
            {
              suggest.map((yacht,idx)=>{
                return(
                
                    <YachtCard
                      slug={yacht.slug}
                      image={yacht.thumbnail.url}
                      altText={yacht.thumbnail.alternativeText}
                      size={yacht.size?.size}
                      model={yacht.model?.model}
                      brand={yacht.brand?.brand}
                      isNew={yacht.isYachtNew}
                      status={yacht.status}
                    />
                  
                )
              })
            }
          </div>
          </div>
        )}
      </article>

    </Layout>
  );
}

const Specs = ({ content }) => {
  const router = useRouter();

  return (
    <div className="mb-4 mb-md-5 mb-lg-6" >
      
      <hr />
      <strong >
        {router.locale === "es" ? "Especificaciones" : "Specifications"}
      </strong>
      
      <div className={styles.specifications}>
        <div className={styles.specificationsSec}id="specifications"/>
        {content?.make && (
          <div className={styles.spect}>
            <span>
              <strong>{router.locale === "es" ? "Marca:" : "Make:"}</strong>
              <p>{content?.make}</p>
            </span>
        </div>
        )}

        {content?.model && (
          <div className={styles.spect}>
            <span>
              <strong>{router.locale === "es" ? "Modelo:" : "Model:"}</strong>
              <p>{content?.model}</p>
            </span>
          </div>
        )}

        {content?.hullMaterial && (
          <div className={styles.spect}>
            <span>
              <strong>{router.locale === "es" ? "Material del casco:" : "Hull Material:"}</strong>
              <p>{content?.hullMaterial}</p>
            </span>
          </div>
        )}

        {content?.engineModel && (
          <div className={styles.largeSpect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="39.983" viewBox="0 0 40 39.983"><g transform="translate(-78.561 -8.648)"><path d="M118.513,28.139a9.43,9.43,0,0,0-1.288-4.176,5.732,5.732,0,0,0-5.595-3.1,11.3,11.3,0,0,0-6.964,2.982c-.012.012-.019.025-.031.037a7.923,7.923,0,0,0-.969-1.025,2.81,2.81,0,0,1,.413-2.244,11.478,11.478,0,0,1,1.138-1.738c.475-.575.994-1.144,1.488-1.688q.619-.675,1.219-1.369a12.865,12.865,0,0,0,1.369-1.838,2.112,2.112,0,0,0-.475-2.838,2.972,2.972,0,0,0-.681-.506l-.35-.175a12.286,12.286,0,0,0-1.544-.681A22.8,22.8,0,0,0,99,8.648a10.147,10.147,0,0,0-5.145,1.375,5.755,5.755,0,0,0-3.038,5.895,12.665,12.665,0,0,0,.619,2.657,10.055,10.055,0,0,0,2.369,4,8.308,8.308,0,0,0-.744.662c-.094.094-.175.2-.262.3a2.763,2.763,0,0,1-2.125-.331,16.114,16.114,0,0,1-3.488-2.532c-.294-.262-.581-.531-.875-.806-.581-.544-1.181-1.107-1.831-1.606a2.671,2.671,0,0,0-2.138-.656,2.733,2.733,0,0,0-1.763,1.438,10.687,10.687,0,0,0-.963,2.182,23.7,23.7,0,0,0-1.031,5.913,10.941,10.941,0,0,0,1.35,6.176,5.82,5.82,0,0,0,5.22,3.107,7.124,7.124,0,0,0,.882-.056A12.493,12.493,0,0,0,90,35.135a9.437,9.437,0,0,0,2.513-1.75,7.192,7.192,0,0,0,1.05,1.088v.1a5.987,5.987,0,0,1-.006.669,5.2,5.2,0,0,1-1,2.313A26.56,26.56,0,0,1,89.583,41.1a13.7,13.7,0,0,0-1.7,2.169,2.091,2.091,0,0,0,.462,2.857,4.113,4.113,0,0,0,.988.688,16.756,16.756,0,0,0,1.982.806,24.129,24.129,0,0,0,5.92.994c.231.012.462.019.688.019a10.561,10.561,0,0,0,5.332-1.363,5.824,5.824,0,0,0,3.094-5.895,11.871,11.871,0,0,0-1.475-4.588,9.015,9.015,0,0,0-1.538-2.1,7.89,7.89,0,0,0,.994-.944,2.372,2.372,0,0,1,1.663.119,8.633,8.633,0,0,1,1.156.575,23.27,23.27,0,0,1,3.882,3.175,13.571,13.571,0,0,0,2.194,1.719,2.268,2.268,0,0,0,1.206.375,2.2,2.2,0,0,0,1.688-.875,6.027,6.027,0,0,0,.963-1.55,21,21,0,0,0,1.431-9.139ZM92.589,18.187a11.537,11.537,0,0,1-.563-2.407,4.521,4.521,0,0,1,2.444-4.72,8.874,8.874,0,0,1,4.538-1.206,21.434,21.434,0,0,1,6.851,1.069,10.127,10.127,0,0,1,1.381.613l.356.175a1.669,1.669,0,0,1,.388.306.935.935,0,0,1,.256,1.338A12.092,12.092,0,0,1,107,15.017c-.388.456-.794.9-1.194,1.344-.506.556-1.031,1.138-1.525,1.732a12.635,12.635,0,0,0-1.263,1.919,4.919,4.919,0,0,0-.644,1.919,7.819,7.819,0,0,0-3.857-1h-.087a7.523,7.523,0,0,0-3.594.95,8.78,8.78,0,0,1-2.244-3.694ZM89.457,34.053a11.252,11.252,0,0,1-3.576,1.119,4.667,4.667,0,0,1-4.895-2.444,9.742,9.742,0,0,1-1.194-5.507,22.494,22.494,0,0,1,.975-5.62,9.816,9.816,0,0,1,.85-1.938,1.625,1.625,0,0,1,.95-.869,1.543,1.543,0,0,1,1.169.431,21.579,21.579,0,0,1,1.738,1.525c.294.281.594.556.894.825a17.312,17.312,0,0,0,3.757,2.707,4.9,4.9,0,0,0,1.744.538,7.769,7.769,0,0,0-.062,7.539,7.654,7.654,0,0,1-2.35,1.694Zm2.626-5.3a6.5,6.5,0,0,1,1.85-4.663A6.353,6.353,0,0,1,98.44,22.15h.075a6.487,6.487,0,1,1-6.432,6.6Zm11.714,8.6a10.821,10.821,0,0,1,1.338,4.126,4.559,4.559,0,0,1-2.488,4.732A9.543,9.543,0,0,1,97.3,47.4a22.917,22.917,0,0,1-5.626-.938,15.474,15.474,0,0,1-1.831-.744,2.973,2.973,0,0,1-.694-.488.9.9,0,0,1-.25-1.313,12.523,12.523,0,0,1,1.544-1.975,26.81,26.81,0,0,0,3.113-3.713,6.4,6.4,0,0,0,1.2-2.857v-.056a7.946,7.946,0,0,0,3.913,1.019H98.8a7.375,7.375,0,0,0,3.513-.963,8.045,8.045,0,0,1,1.488,1.981Zm12.14-.531a4.8,4.8,0,0,1-.763,1.225.886.886,0,0,1-1.313.25,12.792,12.792,0,0,1-2-1.569,24.333,24.333,0,0,0-4.094-3.338,9.926,9.926,0,0,0-1.319-.662,3.84,3.84,0,0,0-1.2-.294,7.521,7.521,0,0,0,1.025-3.863,7.831,7.831,0,0,0-.956-3.669,2.1,2.1,0,0,1,.163-.175,10.123,10.123,0,0,1,6.239-2.669,4.518,4.518,0,0,1,4.463,2.507,8.333,8.333,0,0,1,1.125,3.651,19.529,19.529,0,0,1-1.37,8.608Z" transform="translate(0 0)" fill="#141c3d"/><path d="M304.3,237.656h.062a3.651,3.651,0,0,0-.125-7.3h-.044a3.651,3.651,0,0,0,.106,7.3Zm-1.788-5.363a2.377,2.377,0,0,1,1.694-.725h.031a2.439,2.439,0,0,1,.106,4.876H304.3a2.444,2.444,0,0,1-1.788-4.151Z" transform="translate(-205.686 -205.372)" fill="#141c3d"/></g></svg>
            <span>
              <strong>{router.locale === "es" ? "Modelo del motor:" : "Engine model:"}</strong>
              <p>{content?.engineModel}</p>
            </span>
            
          </div>
        )}

        {content?.draft && (
          <div className={styles.spect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-152 -2937)"><path d="M310.24,156.36a.467.467,0,1,0,.661-.661l-3.268-3.3a.468.468,0,0,0-.51-.1.465.465,0,0,0-.153.1l-3.42,3.3a.467.467,0,0,0,.661.661l2.623-2.5v18.133l-2.623-2.964a.467.467,0,0,0-.661.661l3.421,3.762a.476.476,0,0,0,.331.138.473.473,0,0,0,.331-.137l3.268-3.762a.467.467,0,1,0-.661-.661l-2.47,2.964V153.859Z" transform="translate(-119.413 2795.458)" fill="#141c3d"/><g transform="translate(101 765)"><rect width="40" height="40" transform="translate(51 2172)" fill="none"/><g transform="translate(-0.098 9.574)" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M51.568,2173.147h30.1c.463,0,.426.493.426.493l-3.822,15.326-9.553,3.316-.521,1.859s-.022.355-.47.329H65.48a.337.337,0,0,1-.359-.329l-.557-1.859-10.958-3.316L51.1,2173.754S51.056,2173.154,51.568,2173.147Z" stroke="none"/><path d="M 52.76600646972656 2174.64697265625 L 54.93389129638672 2187.800537109375 L 64.99790954589844 2190.845703125 C 65.47949981689453 2190.991455078125 65.85594940185547 2191.368896484375 66.00035858154297 2191.850830078125 L 66.33572387695312 2192.97021484375 L 66.97200775146484 2192.97021484375 L 67.27857971191406 2191.876708984375 C 67.41117095947266 2191.403564453125 67.7669677734375 2191.025390625 68.23104858398438 2190.864501953125 L 77.01670837402344 2187.81494140625 L 80.30087280273438 2174.64697265625 L 52.76600646972656 2174.64697265625 M 81.67770385742188 2173.14697265625 C 82.13444519042969 2173.14697265625 82.09806060791016 2173.6396484375 82.09806060791016 2173.6396484375 L 78.275634765625 2188.9658203125 L 68.722900390625 2192.281494140625 L 68.20166015625 2194.140869140625 C 68.20166015625 2194.140869140625 68.18111419677734 2194.471435546875 67.77639770507812 2194.471435546875 C 67.76189422607422 2194.471435546875 67.74696350097656 2194.47119140625 67.7314453125 2194.47021484375 L 65.479736328125 2194.47021484375 C 65.1405029296875 2194.493408203125 65.12060546875 2194.140869140625 65.12060546875 2194.140869140625 L 64.5634765625 2192.281494140625 L 53.60570526123047 2188.9658203125 L 51.09862518310547 2173.754150390625 C 51.09862518310547 2173.754150390625 51.05615234375 2173.154296875 51.56787109375 2173.14697265625 L 81.671630859375 2173.14697265625 C 81.67366027832031 2173.14697265625 81.67568969726562 2173.14697265625 81.67770385742188 2173.14697265625 Z" stroke="none" fill="#141c3d"/></g></g></g></svg>
           <span>
             <strong>{router.locale === "es" ? "Calado:" : "Draft:"}</strong>
             <p>{content?.draft}</p>
           </span>
          </div>
        )}

        {content?.maxSpeed && (
          <div className={styles.spect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-24 -29)"><rect width="40" height="40" transform="translate(24 29)" fill="none"/><g transform="translate(-99.004 -55.912)"><path d="M324.889,205.794l-6.389,6.389a3.164,3.164,0,0,0-1.616-.453,3.2,3.2,0,1,0,3.2,3.2,3.167,3.167,0,0,0-.453-1.616l6.389-6.389a.8.8,0,1,0-1.131-1.131Zm-8,10.737a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,316.884,216.53Z" transform="translate(-173.88 -110.017)" fill="#141c3d"/><path d="M157.147,90.77c-.013-.013-.031-.018-.044-.03a19.965,19.965,0,0,0-28.2,0c-.014.012-.032.017-.045.03s-.018.031-.03.045a19.983,19.983,0,0,0,.03,28.241.8.8,0,0,0,1.131,0l1.226-1.226a.8.8,0,0,0-1.131-1.131l-.648.648a18.24,18.24,0,0,1-4.8-11.634h.9a.8.8,0,0,0,0-1.6h-.913a18.327,18.327,0,0,1,4.823-11.626l.64.64A.8.8,0,0,0,131.219,92l-.641-.64A18.328,18.328,0,0,1,142.2,86.533v.913a.8.8,0,0,0,1.6,0v-.913a18.327,18.327,0,0,1,11.626,4.823l-.64.64a.8.8,0,1,0,1.131,1.131l.64-.64a18.328,18.328,0,0,1,4.823,11.626h-.913a.8.8,0,1,0,0,1.6h.9a18.242,18.242,0,0,1-4.8,11.634l-.648-.648a.8.8,0,1,0-1.131,1.131l1.226,1.226a.8.8,0,0,0,1.132,0,19.983,19.983,0,0,0,.03-28.241c-.012-.014-.017-.032-.03-.045Z" fill="#141c3d"/></g></g></svg>
            <span>
              <strong>{router.locale === "es" ? "Max. velocidad:" : "Max. Speed:"}</strong>
              <p>{content?.maxSpeed}</p>
            </span>
          </div>
        )}

        {content?.passengers && (
          <div className={styles.spect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-51 -2163)"><rect width="40" height="40" transform="translate(51 2163)" fill="none"/><g transform="translate(-38.598 2128.817)"><path d="M460.2,44.609A4.607,4.607,0,1,1,464.806,40,4.612,4.612,0,0,1,460.2,44.609Zm0-7.922A3.316,3.316,0,1,0,463.516,40,3.32,3.32,0,0,0,460.2,36.687Z" transform="translate(-337.885)"/><path d="M432.277,177.421h-3.342a2.571,2.571,0,0,1-2.551-2.363l-.7-9.085h-.242a.645.645,0,0,1,0-1.29h.839a.645.645,0,0,1,.643.6l.749,9.681a1.274,1.274,0,0,0,1.265,1.172h3.342a1.274,1.274,0,0,0,1.265-1.172l.749-9.681a.645.645,0,0,1,.643-.6H436.2a.4.4,0,0,0,.4-.405v-5.852a3.771,3.771,0,0,0-3.766-3.766h-4.456a3.753,3.753,0,0,0-3.58,2.589.645.645,0,1,1-1.227-.4,5.04,5.04,0,0,1,4.807-3.48h4.456a5.062,5.062,0,0,1,5.056,5.057v5.852a1.694,1.694,0,0,1-1.689,1.7h-.671l-.7,9.085a2.571,2.571,0,0,1-2.551,2.363Z" transform="translate(-308.293 -108.913)"/><path d="M129.06,44.609A4.607,4.607,0,1,1,133.666,40,4.612,4.612,0,0,1,129.06,44.609Zm0-7.922A3.316,3.316,0,1,0,132.376,40,3.32,3.32,0,0,0,129.06,36.687Z" transform="translate(-32.178)"/><path d="M98.554,177.422H95.212a2.571,2.571,0,0,1-2.551-2.363l-.7-9.085h-.671a1.694,1.694,0,0,1-1.688-1.7v-5.852a5.062,5.062,0,0,1,5.057-5.057h4.456a5.04,5.04,0,0,1,4.807,3.48.645.645,0,1,1-1.227.4,3.753,3.753,0,0,0-3.58-2.589H94.655a3.77,3.77,0,0,0-3.766,3.766v5.852a.4.4,0,0,0,.4.405h1.268a.645.645,0,0,1,.643.6l.749,9.68a1.275,1.275,0,0,0,1.265,1.172h3.342a1.274,1.274,0,0,0,1.265-1.172l.749-9.68a.645.645,0,0,1,.643-.6h.839a.645.645,0,0,1,0,1.29h-.242l-.7,9.085a2.571,2.571,0,0,1-2.551,2.363Z" transform="translate(0 -108.914)"/><path d="M288.106,47.01a5.149,5.149,0,1,1,5.149-5.149A5.155,5.155,0,0,1,288.106,47.01Zm0-9.008a3.859,3.859,0,1,0,3.859,3.859A3.863,3.863,0,0,0,288.106,38Z" transform="translate(-178.508 -1.215)"/><path d="M253.383,197.986h-3.8a2.834,2.834,0,0,1-2.812-2.6l-.8-10.416h-.841a1.839,1.839,0,0,1-1.837-1.837v-6.653a5.669,5.669,0,0,1,5.66-5.664h5.071a5.669,5.669,0,0,1,5.66,5.664v6.653a1.839,1.839,0,0,1-1.837,1.837H257l-.8,10.416a2.833,2.833,0,0,1-2.812,2.6ZM248.948,172.1a4.377,4.377,0,0,0-4.37,4.374v6.653a.548.548,0,0,0,.547.547h1.439a.645.645,0,0,1,.643.6l.85,11.011a1.537,1.537,0,0,0,1.526,1.413h3.8a1.538,1.538,0,0,0,1.526-1.412l.85-11.012a.645.645,0,0,1,.643-.6h1.439a.548.548,0,0,0,.547-.547v-6.653a4.377,4.377,0,0,0-4.37-4.374Z" transform="translate(-141.885 -125.016)"/></g></g></svg>
            <span>
              <strong>{router.locale === "es" ? "Pasajeros:" : "passengers:"}</strong>
              <p>{content?.passengers}</p>
            </span>
          </div>
        )}

        {content?.yacthLength && (
          <div className={styles.spect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="40" viewBox="0 0 80 40"><g transform="translate(-51 -2172)"><rect width="80" height="40" transform="translate(51 2172)" fill="none"/><g transform="translate(-64.122 2052.243)"><g transform="translate(115.122 137.118)"><path d="M171.649,182.1H126.518a.612.612,0,0,1-.47-.213l-2.647-2.925-7.664-.3a.636.636,0,0,1-.555-.363.626.626,0,0,1,.085-.662l5.23-6.575a.638.638,0,0,1,.491-.235h25.277l4.974-2.263a.568.568,0,0,1,.256-.064h43a.622.622,0,0,1,.6.427.629.629,0,0,1-.213.7C194.214,170.144,178.374,182.1,171.649,182.1ZM126.8,180.818h44.854c5.124,0,16.673-8.006,20.879-11.037H151.645l-4.974,2.263a.569.569,0,0,1-.256.064H121.309l-4.248,5.337,6.661.256a.6.6,0,0,1,.448.213Z" transform="translate(-115.122 -168.5)" fill="#141c3d"/></g><g transform="translate(131.385 131.973)"><path d="M191.94,153.153a.623.623,0,0,1-.6-.406.655.655,0,0,1,.363-.833l19.7-7.472a.768.768,0,0,1,.235-.043h18.808a.639.639,0,0,1,.384.128l7.024,5.188a.64.64,0,1,1-.769,1.025l-6.853-5.081H211.773l-19.6,7.429A.487.487,0,0,1,191.94,153.153Z" transform="translate(-191.3 -144.4)" fill="#141c3d"/></g><g transform="translate(143.879 128.6)"><path d="M276.483,133.254H250.459a.641.641,0,0,1-.619-.491.658.658,0,0,1,.342-.726l6.618-3.373a.682.682,0,0,1,.3-.064h15.179a.6.6,0,0,1,.406.149l4.227,3.373a.639.639,0,0,1,.213.7A.677.677,0,0,1,276.483,133.254Zm-23.355-1.281h21.519l-2.626-2.092H257.227Z" transform="translate(-249.824 -128.6)" fill="#141c3d"/></g></g></g></svg>
           <span>
             <strong>{router.locale === "es" ? "Eslora:" : "Length:"}</strong>
             <p>{content?.yacthLength}</p>
           </span>
         </div>
        )}

        {content?.fuelType && (
          <div className={styles.spect}>
            <span>
              <strong>{router.locale === "es" ? "Combustible:" : "Fuel Type:"}</strong>
              <p>{content?.fuelType}</p>
            </span>
          </div>
        )}

        {content?.fuelCapacity && (
           <div className={styles.spect}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-51 -2172)"><rect width="40" height="40" transform="translate(51 2172)" fill="none"/><g transform="translate(-106.866 2089.403)"><path d="M191.835,82.6H179.687a4.97,4.97,0,0,0-4.965,4.965V92.4l-.389.328-1.874-1.874a.56.56,0,0,0-.068-.046.572.572,0,0,0-.1-.065.586.586,0,0,0-.11-.031.518.518,0,0,0-.1-.019.574.574,0,0,0-.124.013.47.47,0,0,0-.086.017.569.569,0,0,0-.124.068.437.437,0,0,0-.057.031l-.036.03h0l-.743.627-.456-.463c-4.482-4.566-8.338-8.507-12.02-8.423h-.021a.525.525,0,0,0-.1.023.564.564,0,0,0-.113.026.542.542,0,0,0-.088.059.582.582,0,0,0-.09.064.6.6,0,0,0-.06.089.572.572,0,0,0-.059.093.589.589,0,0,0-.022.11.529.529,0,0,0-.021.1v3.7a.5.5,0,0,0,.019.095.567.567,0,0,0,.022.11.539.539,0,0,0,.055.094.57.57,0,0,0,.06.089.6.6,0,0,0,.086.066.539.539,0,0,0,.089.06.6.6,0,0,0,.11.03.47.47,0,0,0,.091.024c2.4.145,5.212,3.2,8.47,6.734l.382.414-1.264,1.067c-.006.005-.009.013-.015.018s-.013.007-.017.012a.584.584,0,0,0-.044.065.536.536,0,0,0-.072.108.578.578,0,0,0-.021.074.589.589,0,0,0-.027.14.466.466,0,0,0,.007.062.536.536,0,0,0,.03.153.528.528,0,0,0,.029.053.581.581,0,0,0,.063.115c.008.009.019.012.027.021s0,.009.009.013l1.806,1.806L166.086,99.7a4.984,4.984,0,0,0-1.627,3.676v14.257a4.97,4.97,0,0,0,4.965,4.965h22.411a4.97,4.97,0,0,0,4.965-4.965V87.561a4.968,4.968,0,0,0-4.963-4.964ZM167.7,93.395c-3.211-3.486-6.013-6.524-8.7-7.031V83.757c3.065.323,6.59,3.924,10.649,8.06l.4.4-1.926,1.626Zm-.51,2.717,1.249-1.053s.011-.005.015-.009,0-.006.006-.009l2.811-2.372,0,0a0,0,0,0,0,0,0l.748-.631,1.435,1.435-4.833,4.082Zm28.471,21.522a3.834,3.834,0,0,1-3.83,3.83H169.424a3.834,3.834,0,0,1-3.83-3.83V103.375a3.839,3.839,0,0,1,1.24-2.823l2.155-1.82s.011-.005.014-.009l0-.006,5.631-4.755a.509.509,0,0,0,.075-.049c.009-.009.012-.021.021-.03l.922-.779a.566.566,0,0,0,.2-.435V87.562a3.834,3.834,0,0,1,3.83-3.83h12.147a3.835,3.835,0,0,1,3.83,3.83Z" fill="#141c3d"/><path d="M374.524,113.4H364.4a2.136,2.136,0,0,0-2.133,2.133v2.116a2.136,2.136,0,0,0,2.133,2.133h10.129a2.136,2.136,0,0,0,2.133-2.133v-2.116a2.136,2.136,0,0,0-2.133-2.133Zm1,4.25a1,1,0,0,1-1,1H364.4a1,1,0,0,1-1-1v-2.116a1,1,0,0,1,1-1h10.129a1,1,0,0,1,1,1Z" transform="translate(-183.687 -27.682)" fill="#141c3d"/><path d="M336.356,260.093a.566.566,0,0,0-.8,0l-6.6,6.6-6.6-6.6a.567.567,0,0,0-.8.8l6.6,6.6-6.6,6.6a.567.567,0,0,0,.8.8l6.6-6.6,6.6,6.6a.567.567,0,0,0,.8-.8l-6.6-6.6,6.6-6.6a.568.568,0,0,0,0-.8Z" transform="translate(-146.957 -159.363)" fill="#141c3d"/></g></g></svg>
              <span>
                <strong>{router.locale === "es" ? "Capacidad de combustible:" : "Fuel Capacity:"}</strong>
                <p>{content?.fuelCapacity}</p>
              </span>
            </div>
        )}

        {content?.grossWeight && (
          <div className={styles.spect}>
            <svg xmlns="http://www.w3.org/2000/svg" width="39.7" height="40" viewBox="0 0 39.703 40"><path d="M100.252,26.422h6.885V23.933H92.618a2.47,2.47,0,0,1-2.46-2.46v-3.26h39.7v3.26a2.47,2.47,0,0,1-2.46,2.46H112.881v2.489h6.89a4.077,4.077,0,0,1,3.977,3.213l5.986,23.51a4.071,4.071,0,0,1-3.94,5.069H94.23a3.971,3.971,0,0,1-1.2-.178,4.1,4.1,0,0,1-2.876-3.888A4.008,4.008,0,0,1,90.329,53l5.983-23.509a4.083,4.083,0,0,1,3.94-3.066Zm7.614-3.987H127.4a.961.961,0,0,0,.962-.962V19.711H91.655v1.762a.961.961,0,0,0,.962.962Zm.768,1.5v2.489h2.749V23.933Zm2.211,17.92a1.255,1.255,0,0,1,.054.228,1.211,1.211,0,1,1-1.126-1.039l4.179-4.407-3.108,5.218Zm-.836-10.644a11.115,11.115,0,1,1-7.855,3.257A11.076,11.076,0,0,1,110.009,31.209Zm6.8,4.311a9.619,9.619,0,1,0,2.814,6.8A9.583,9.583,0,0,0,116.807,35.52Zm2.965-7.6H100.252a2.578,2.578,0,0,0-2.49,1.939l-6,23.544a2.526,2.526,0,0,0-.111.744,2.562,2.562,0,0,0,2.575,2.572h31.564a2.671,2.671,0,0,0,.622-.079,2.6,2.6,0,0,0,1.947-2.5,2.567,2.567,0,0,0-.078-.627l-5.991-23.545a2.575,2.575,0,0,0-2.523-2.048Z" transform="translate(-90.158 -18.213)" fill="#141c3d"/></svg>
            <span>
              <strong>{router.locale === "es" ? "Peso total:" : "Gross Weight:"}</strong>
              <p>{content?.grossWeight}</p>
            </span>
          </div>
        )}

      </div>
     
    </div>
  );
};

const Spec = ({ content }) => {
  const router = useRouter();

  return (
    <div className="mb-4 mb-md-5 mb-lg-6" >
      
      <hr />
      <strong >
        {router.locale === "es" ? "Especificaciones" : "Specifications"}
      </strong>
      
      <div className={styles.specifications}>
        <div className={styles.specificationsSec}id="specifications"/>
        {
          content.map((spect,idx)=>{
            return(
              <div className={spect.feature.large === true ? styles.largeSpect : styles.spect}>
                <img style={{width: '40px', height: '40px'}} src={spect.feature.icon[0].url} alt="icon" />
                <span>
                  <strong>{router.locale === "es" ? spect.feature.name_es : spect.feature.name}</strong>
                  <p>{router.locale === 'es' ? spect.value_es : spect.value}</p>
                </span>
              </div>
            )
          })
        }
      </div>
     
    </div>
  );
};

const Description = ({ content }) => {
  const router = useRouter();
  return (
    <div id="description" className="mb-4 mb-md-5 mb-lg-6">
      <hr className="mt-0 mb-4"/>
      <ReactMarkdown className="description">{content}</ReactMarkdown>
    </div>
  );
};

const Features = ({ content }) => {
  const router = useRouter();
  return (
    <div id="features">
      <hr className={styles.hr}/>
      <strong>
        {router.locale === "es" ? "Funciones y opciones" : "Features & options"}
      </strong>
      <br/>

      <Row className="mx-0 ps-0" as="ul">
        {content?.map((option, index) => {
          return (
            <Col
              key={index}
              xs={6}
              md={4}
              lg={3}
              className="d-flex ps-0 "
              as="li"
            >
              <span className="h3 me-3 fw-bold">&#43;</span>
              <span className={styles.featureLabel}>{option?.name}</span>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const FormAppointment = ({slug, text}) => {
  
  
  const router = useRouter();
  const [contactStatus, setContactStatus] = useState(false)
  const [show, setShow] = useState(false)
  const [name, setName] = useState('')
  const [disabled, setDisabled] = useState(true);


  const [gclid, setGclid] = useState(undefined)
  const form = useRef();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { register, handleSubmit, reset, getValues, formState: { errors }} = useForm();

  const handleRequired = (e) => {
    let inputs = Object.values(getValues())
    
    let invalids = inputs.filter(item => item == '')
    if(invalids.length < 1)
      setDisabled(false)
    else
      setDisabled(true)
  }

  useEffect(() => {
    const gclid = sessionStorage.getItem('gclid');
    if (gclid) {
      setGclid(gclid)
    }
    
  }, [])

  
  const onSubmit = (data) => { 
    setContactStatus("waiting");
    emailjs.send(process.env.NEXT_PUBLIC_EMAILJS_SERVICE, process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE, data, process.env.NEXT_PUBLIC_EMAILJS_USER)
        .then(() => {
          setContactStatus("sent");
          setTimeout(setContactStatus(false), 3000);
          setShow(true);
          reset({
            user_name: '',
            user_phone: '',
            user_email: '',
            user_message : ''
          })
          setName(data.user_name)
          
          try{
            fbq.event('Lead',{value: slug})
          }catch(e){
            console.log(e)
          }
        }, (error) => {
          console.error(error)
          setContactStatus("error");
        });
    
    
  };

  
 
  return (
    <>
    <aside className={styles.aside} >
      {Boolean(contactStatus !== "sent" && contactStatus !== "error") && (
        <>
          <h3>
            {router.locale === "es"
              ? "Agenda una cita"
              : "Schedule your appointment"}
          </h3>

          <form id="yachtForm" className="yatch-form" onSubmit={handleSubmit(onSubmit)} ref={form}>
            
            <div className="mb-1 contact-input">
              <label for="user_name" className={styles.labelInput}>{router.locale === "es" ? "Nombre" : "Your Name"}</label>
              <input
                type="text"
                className='form-control'
                name="user_name"
                {...register("user_name", {
                  required: true,
                  onChange: handleRequired
                  })
                }
              />
              {
                errors.user_name && errors.user_name.type === 'required' && (
                <span >
                  {router.locale === "es" ? "Ingresa tu nombre" : "Write your name"}
                </span>
                )
              }
            </div>

            <div className="mb-1 contact-input" >
              <label for="user_phone" className={styles.labelInput}>{router.locale === "es" ? "Teléfono" : "Phone"}</label>
              <input
                type="phone"
                className='form-control'
                name="user_phone"
                
                {...register("user_phone", {
                  required: true,
                  onChange: handleRequired,
                  pattern: {
                    value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                  }
                  })
                }
              />
              {
                  errors.user_phone && errors.user_phone.type === 'required' && (
                <span>
                  {router.locale === "es" ? "Ingresa un teléfono válido" : "Write a valid phone"}
                </span>
                  )
              }
            </div>

            <div className="mb-1 contact-input" >
              <label for="user_email" className={styles.labelInput}>{router.locale === "es" ? "Correo" : "Mail"}</label>
              <input
                type="email"
                className='form-control'
                name="user_email"
                
                {...register("user_email", {
                  required: true,
                  onChange: handleRequired,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  }
                  })
                }
              />
              {
                  errors.user_email && errors.user_email.type === 'required' && (
                <span>
                  {router.locale === "es" ? "Ingresa un correo válido" : "Write a valid email"}
                </span>
                  )
              }
            </div>

            <div className="mb-3 contact-input ">
              <label for="user_message" className={styles.labelInput}>{router.locale === "es" ? "Mensaje" : "Message"}</label>
              <textarea
                rows={5}
                className='form-control'
                name="user_message"
                {...register("user_message", {
                  required: "required",
                  onChange: handleRequired
                  })
                }
              />
              {
                errors.user_message && errors.user_message.type === 'required' && (
                <span>
                  {router.locale === "es" ? "Cuéntanos algo" : "Tell us something"}
                </span>
                )
              }
            </div>

            <input type="hidden" name="gclid" value={gclid} />

            <Button
              disabled = { disabled }
              variant="primary"
              type="submit"
              className="w-100"
            >
              {!contactStatus
                ? router.locale === "es" ? "Agendar visita" : "Schedule appointment"
                : contactStatus === "waiting"
                  ? router.locale === "es" ? "Enviando..." : "Sending..."
                  : contactStatus === "sent"
                    ? router.locale === "es" ? "Mensaje enviado" : "Message sent"
                    : router.locale === "es" ? "Intenta de nuevo" : "Try again"
              }
            </Button>
          </form>
        </>
      )}
      {contactStatus === "error" &&
        <Col md={12}>
          <div >
            <div className={styles.contact_error}>
              <div className="error-image">
                <ErrorForm />
              </div>
              <div style={{ fontSize: "32px" }}>
                {
                  router.locale === "es" ? "¡Lo sentimos!" : "Sorry!"
                }
              </div>
              <div className="error-message">
                {
                  router.locale === "es"
                    ? "Ocurrió un error al enviar tu mensaje, por favor intenta de nuevo o ponte en contacto con nosotros directamente."
                    : "There was an error while sending your message, please try again later or contact us directly."
                }
              </div>

              <Button
                type="submit"
                variant="primary"
                className="w-100 mt-4 py-3 fw-bold text-uppercase"
                onClick={() => { setContactStatus(undefined) }}
              >
                {router.locale === "es" ? "Intentar de nuevo" : "Try again"}
              </Button>
            </div>
          </div>
        </Col>
      }
    </aside>

    <Modal show={show} onHide={handleClose} centered  size="md">
                
      <Modal.Body className={styles.yachtContact}>
        <Lottie
          animationData={lottieJson}
          play
          loop={false}
          style={{ width: 150, height: 150 }}
        />
        <ReactMarkdown>{text}</ReactMarkdown>
        <Button
          variant="primary"
          type="button"
          onClick={handleClose}
        >
          {router.locale === 'es' ? 'Continuar' : "Continue"}
        </Button>
      </Modal.Body>             
    </Modal>

    </>
  );
};

const FrameYoutube = ({ url, locale }) => {
  const [showYoutube, setYoutube] = useState(false);

  const openYoutube = () => setYoutube(true);
  const closeYoutube = () => setYoutube(false);
  
  return (
    <>
    <Button
      variant="outline-primary"
      className={styles.btn_section}
      onClick={openYoutube}
    >
      {locale === "es" ? "Tour en video" : "Video Tour"}
    </Button>

    <Modal show={showYoutube} onHide={closeYoutube} centered size='xl'>
      <Modal.Body >
        <iframe className={styles.youtube} src={url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </Modal.Body>             
    </Modal>
    </>
  );
};

const View3D = ({ url, locale }) => {
  const [show3D, set3D] = useState(false);

  const open3D = () => set3D(true);
  const close3D = () => set3D(false);
  
  return (
    <>
    <Button
      variant="outline-primary"
      className={styles.btn_section}
      onClick={open3D}
    >
      {locale === "es" ? "Tour en 3D" : "3D View"}
    </Button>

    <Modal show={show3D} onHide={close3D} centered size="lg">
      <Modal.Body >
        <iframe id="3DTour" src={url} className={styles.view3d} frameBorder="0" scrolling="no" />
      </Modal.Body>             
    </Modal>
    </>
  );
};

const Levels = ({levels, locale}) => {
 
  const [level, setLevel] = useState(levels[0]);
  const [layout, setLayout] = useState(levels[0].layout[0]);

  return(
  <div className={styles.levels} id='design'>
    
    <div className={styles.levelsImage}>
      <hr />
      <strong>{locale == 'es' ? 'Diseño' : 'Design'}</strong>
      <ImageMagnifier src={layout.imagen.url} zoomLevel={1.5} />
    </div>
    <div className={styles.levelsWrapper}>

      <strong>{locale == 'es' ? 'Vista' : 'View'}</strong>
      <div className={styles.levelsWrapperList}>
        {
          levels.map((item, idx)=>{
            return(
              <Button 
                className="rounded" 
                variant={level == item ? 'primary': "outline-primary"}
                onClick={
                  ()=>{
                    setLevel(item)
                    setLayout(item.layout[0])
                  }
                }
              >
                {locale == 'es'  ? item.name_es : item.name}
              </Button >
            )
          })
        }
      </div>
      <hr />

      
        { level.layout.length > 1 &&(
          <>
            <strong>{locale == 'es'? 'Personalización' : 'Layout'}</strong>
            <div className={styles.levelsWrapperList}>
            {
              level.layout.map((item,idx)=>{
                return(
                  <Button  
                    className="rounded" 
                    variant={layout == item ? 'primary': "outline-primary"}
                    onClick={()=>setLayout(item)} 
                  >
                    {locale == 'es'? 'Opción '+(idx+1): 'Option '+(idx+1)}
                  </Button>
                )
              })
            }
            </div>
          </>
                 
        )}
        
     
      <ReactMarkdown className="mt-3">{locale == 'es' ? (layout.info_es ?? layout.info_es) : (layout.info ?? layout.info) }</ReactMarkdown>


    </div>
    
  
  </div>
  )
}

const GalleryMovil = ({data, openGallery})=>{
  const [idx, setIdx] = useState(0);
  const handleSelect = (selected, e) =>{
    setIdx(selected)
  }
  const total = data.exterior?.length + data.interior?.length
  return(
    <div className={styles.galleryMovil}>

      <Carousel indicators={false} nextIcon={false} prevIcon={null} activeIndex={idx} onSelect={handleSelect}>
        
        {
          data.exterior?.length > 0 &&(
            data.exterior.map((item,idx)=>{
              return(
                <Carousel.Item>
                <div onClick={openGallery}  id={'ext'+idx} className={idx < 1 ? styles.slideMovilFirst : styles.slideMovil}>
                  <img
                    loading="lazy"
                    alt={'exterior'+idx}
                    src={item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_800/yachting-')}
                  />
                  {
                    idx == 0 ? <h3>{data.title}</h3> : '' 
                  }
                </div>
                </Carousel.Item>
              )
              })
            )
            
          
        
        }
        { data.interior?.length > 0 && (
            data.interior.map((item,idx)=>{
              return(
                <Carousel.Item>
                <div className={styles.slideMovil} onClick={openGallery}>
                  <img
                    alt={"interior"+idx}
                    src={item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_800/yachting-')}
                    loading="lazy"
                  />
                </div>
                </Carousel.Item>
              )
            })
          )
        }
        <span className={styles.galleryLabel}>{`${idx+1}/${total+1}`}</span>
      </Carousel>
   
  </div>
  )
}

const Gallery = ({data, openGallery, showGallery, closeGallery, locale}) =>{
  

  const [interior, showInterior] = useState({
		toggler: false,
		slide: 1
	});
  const [exterior, showExterior] = useState({
		toggler: false,
		slide: 1
	});

  const openExterior = (number) =>{
    showExterior({toggler: !exterior.toggler,	slide: number});
  }
  const exteriors = [];
  const openInterior = (number) =>{
    showInterior({toggler: !interior.toggler,	slide: number});
  }
  const interiors = [];

  return(
    <section className={styles.gallery} id="gallery">
          <Modal show={showGallery} onHide={closeGallery} centered fullscreen={showGallery}>
            <Modal.Header className={styles.galleryHeader}>
              <span onClick={closeGallery}>{locale == 'es' ? 'Regresar' : 'Back'}</span>
              <Scrollspy
                items={['exterior', 'interior']}
                currentClassName='currentScroll'
                className="row justify-content-md-center"
                rootEl='.modal-body'
              >
                <Button href='#exterior' variant="outline-primary" className={styles.btn_section}>Exterior</Button>
                <Button href="#interior" variant='outline-primary' className={styles.btn_section}>Interior</Button>
              </Scrollspy>
              
            </Modal.Header>
            <Modal.Body className={styles.galleryBody}>
              <h3>Exterior</h3>
              <div>
                <div className={styles.galleryExterior} id='exterior'>
                {
                  data.exterior.map((item,idx)=>{
                    exteriors.push(item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1200/yachting-'))
                    return(
                      <div 
                        id={'ext'+idx} 
                        onClick={()=>openExterior(idx+1)} 
                        className={ (idx+1)%3==0 ? styles.galleryExteriorLarge : (idx == 1 ? styles.galleryExteriorLarge : idx == 0 ? styles.galleryExteriorCero : '' )}>
                          <img
                            alt={'exterior'+idx}
                            src={item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1200/yachting-')}
                          />
                      </div>
                    )
                  })
                }
                </div>
                <FsLightbox
                  toggler={exterior.toggler}
                  sources={exteriors}
                  slide={exterior.slide}
                />
             
              </div>

              <h3>Interior</h3>
              <div>
                <div className={styles.galleryInterior} id='interior'>
                {
                  data.interior.map((item,idx)=>{
                    interiors.push(item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1200/yachting-'))
                    return(
                      <div 
                        onClick={()=>openInterior(idx+1)} 
                        className={(idx+1)%3==0 ? styles.galleryInteriorLarge : (idx==1 ? styles.galleryInteriorLarge : (idx == 0? styles.galleryInteriorCero : ''))}
                      >
                          <img
                            alt={"interior"+idx}
                            src={item.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1200/yachting-')}
                            width={1200}
                            height='auto'
                          />
                      </div>
                    )
                  })
                }
                </div>
                <FsLightbox
                  toggler={interior.toggler}
                  sources={interiors}
                  slide={interior.slide}
                />
              </div>
            </Modal.Body>             
          </Modal>
          {data.exterior.length > 0 && (
            <a onClick={()=>openGallery()} href="#exterior" className={styles.galleryButton}>
                <Image
                  src={data.exterior[0].url}
                  alt={data.exterior[0].name}
                  loading='lazy'
                  width="1139"
                  height="653"  
                />
                <h3>Exterior</h3>
            </a>
          )}
          {data.interior.length > 0 && (
            <a onClick={()=>openGallery()} href="#interior" className={styles.galleryButton}>
               
                <Image
                  src={data.interior[0].url}
                  alt={data.interior[0].name}
                  loading='lazy'
                  width="1139"
                  height="653"
                />
                 <h3>Interior</h3>
            </a>
          )} 
        </section>
  )
}